import React, { useState } from 'react';
import { Modal, Button, ModalHeader, ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {authUserManager} from "../../helpers/api_helper";
import {notificationService} from "../../helpers/NotificationService";

const QrCodeModal = () => {
  const { t } = useTranslation();
  let { eventId } = useParams();
  if (authUserManager.isClubAdmin()) {
    eventId = authUserManager.getAuthUser().eventId
  }
  const [modal_qr, setmodal_qr] = useState(false);
  function modal_qr_toggle() {
    setmodal_qr(!modal_qr);
  }
  const src = `${process.env.REACT_APP_API_PUBLIC_URL.replace(/\/$/, '')}/qr/` + "qr_" + eventId + ".svg";

  // Adres, pod którym gość dołącza do wydarzenia — ten sam, który koduje QR.
  const eventUrl = `${window.location.origin}/event/${eventId}`;

  const handleCopyLink = async () => {
    try {
      // navigator.clipboard nie istnieje poza HTTPS i w starszych przeglądarkach
      // na telefonach — stąd fallback na ukryte pole i execCommand.
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(eventUrl);
      } else {
        const area = document.createElement('textarea');
        area.value = eventUrl;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        const copied = document.execCommand('copy');
        document.body.removeChild(area);
        if (!copied) throw new Error('execCommand failed');
      }
      notificationService.success(t('Event link copied'));
    } catch (e) {
      notificationService.error(t('Failed to copy event link'));
    }
  };

  const handleDownload = () => {
    const downloadUrl = `${process.env.REACT_APP_API_URL}/qr/download/qr_${eventId}.svg`;
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `qr_${eventId}.svg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

    return (
      <>
        <div className="ms-sm-1 header-item d-flex">
          <Button
            title={t('Event QR Code')}
            type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
            color="primary" onClick={() => modal_qr_toggle()}
          >
            <i className='bx bx-qr fs-22'></i>
          </Button>
        </div>
        <Modal id="myModal"
               isOpen={modal_qr}
               toggle={() => {
                 modal_qr_toggle();
               }}
        >
          <ModalHeader className="modal-title"
                       id="myModalLabel" toggle={() => {
            modal_qr_toggle();
          }}>
            {t('QR Code')}
          </ModalHeader>
          <ModalBody>
            <h5 className="fs-14">
              {t('Share the qr code with others so they can join the event')}
            </h5>
            <div className="row pt-3 d-flex justify-content-center">
                <img src={src} className="img-fluid "/>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end flex-wrap">
              <Button
                color="light"
                onClick={() => {
                  modal_qr_toggle();
                }}
              >
                <i className="ri-close-circle-line align-middle me-1"></i>
                {t('Close')}
              </Button>
              {authUserManager.isClubAdmin() && (
                <>
                  <Button
                    className="btn-label text-nowrap"
                    color="info"
                    onClick={handleCopyLink}
                  >
                    <i className="ri-link label-icon align-middle fs-16 me-2"></i>
                    {t('Copy Event Link')}
                  </Button>
                  <Button
                    className="btn-label color-primary text-nowrap"
                    color="success"
                    onClick={handleDownload}
                  >
                    <i className="ri-download-line label-icon align-middle fs-16 me-2"></i>
                    {t('Download QR Code')}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Modal>
      </>
    );
};

export default QrCodeModal;
